import { createFileRoute, Outlet } from '@tanstack/react-router'

import { ActivityTabs } from '@/features/activity/components/tabs/tabs'
import { activityQueries } from '@/features/activity/queries'
import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import {
	Section,
	SectionDescription,
	SectionTitle,
} from '@/features/app-shell/section'

import { getCurrentTenant } from '@/shared/auth/store'
import { TableFullSkeleton } from '@/shared/data-table/components/table-skeleton'

import { Skeleton } from '@/components/ui/skeleton'

export const Route = createFileRoute('/_dashboard/activity')({
	loader: ({ context: { queryClient } }) => {
		const tenant = getCurrentTenant()

		if (tenant) {
			queryClient.prefetchInfiniteQuery(activityQueries.list(tenant))
			queryClient.prefetchInfiniteQuery(activityQueries.listPlaybooks(tenant))
		}
	},

	head: () => ({
		meta: [
			{
				title: 'Activity | BitLyft AIR®',
			},
		],
	}),

	component: ActionsActivityRoute,
	pendingComponent: ActionsActivityRouteSkeleton,
	errorComponent: RouteErrorComponent,
})

/**
 * Actions Activity Route
 */
function ActionsActivityRoute() {
	return (
		<Section>
			<SectionTitle>Activity</SectionTitle>
			<SectionDescription>
				View a history of previously run actions and playbooks, including
				execution status, duration, and results.
			</SectionDescription>
			<ActivityTabs />

			<Outlet />
		</Section>
	)
}

/**
 * Loading state for Actions Activity
 */
function ActionsActivityRouteSkeleton() {
	return (
		<Section>
			<SectionTitle>Activity</SectionTitle>
			<SectionDescription>
				View a history of previously run actions and playbooks, including
				execution status, duration, and results.
			</SectionDescription>

			{/* Tabs skeleton */}

			<Skeleton className="hidden h-10 w-48 sm:block" />
			<Skeleton className="h-10 w-full sm:hidden" />

			<TableFullSkeleton rows={15} withFilters withLastUpdated />
		</Section>
	)
}
